<template>
    <div class="echart-line"  ref="echartsBarRef" style="height: 400px; width: 100%"></div>
</template>

<script>
import * as echarts from 'echarts';
import macarons from  '@/apis/macarons'
import {getHomeExpendBar} from "@/apis/static";
export default {
    name: 'EchartExpendBar',
    props : {
        search : Object
    },
    components: {

    },
    data () {
        return {
            option: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: [],
                        axisLabel: {
                            rotate: 30 // 旋转45度
                        },
                        axisTick: {
                            alignWithLabel: true
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: '项目采购金额',
                        type: 'bar',
                        barWidth: 30,
                        data: [],
                        itemStyle: {
                            color: 'orange'
                        }
                    }
                ]
            }
        }
    },
    created(){

    },
    mounted(){
        this.$nextTick(() => {
            this.GetBarEchart();
        })
    },
    methods:{
        GetBarEchart(){
            let that = this;
            getHomeExpendBar().then(e=>{
                that.option.xAxis[0].data = e.data.date ?? [];
                that.option.series[0].data = e.data.money_data ?? [];
                const chartDom = that.$refs.echartsBarRef;
                echarts.registerTheme('macarons', macarons);
                const myChart = echarts.init(chartDom, macarons);
                myChart.setOption(that.option);
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
